/**
 * Created by spepa on 28.02.2024
 */

const PromoCodes = function () {};

PromoCodes.prototype.hasAvailableCodes = function () {
    for (const code in PromoCodes.CODES) {
        if (this.canUseCode(code)) {
            return true;
        }
    }
    return false;
};

PromoCodes.prototype.isUsedCode = function (code) {
    const used = cleverapps.dataLoader.load(DataLoader.TYPES.PROMOCODES) || [];
    return used.includes(code);
};

PromoCodes.prototype.canUseCode = function (code) {
    if (!code || this.isUsedCode(code)) {
        return false;
    }

    const config = PromoCodes.CODES[code];
    if (!config || (config.available && !levels.user.checkAvailable(config.available))) {
        return false;
    }
    return true;
};

PromoCodes.prototype.save = function (code) {
    const used = cleverapps.dataLoader.load(DataLoader.TYPES.PROMOCODES) || [];
    cleverapps.dataLoader.save(DataLoader.TYPES.PROMOCODES, used.concat(code));
};

PromoCodes.prototype.useCode = function (code) {
    if (!this.canUseCode(code)) {
        return false;
    }
    cleverapps.metrics.logEvent(cleverapps.EVENTS.PROMOCODE_REWARD + code);
    this.save(code);
    return PromoCodes.CODES[code].reward;
};

PromoCodes.CODES = {};